import { useResolvedTheme } from '@/hooks/theme/useResolvedTheme';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';

export default function useModalVersion() {
  const { components } = useResolvedTheme();
  const version: string =
    components.get(ComponentTypeId.Modal?.toString())?.toString() ??
    SettingLayoutComponentId.ModalV1?.toString();

  return { version };
}
